module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABAAgMAAACYWpqdAAAACVBMVEUAbaDt7UroRlBrqATAAAAAHUlEQVR4AWOAgVAoWAUFeCRGJUYlRiVGJUYlRiUAgwH+ECrLaDMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/RO-ro.png
// module id = 191
// module chunks = 0